// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")

import PhotoSwipe from 'photoswipe'
import PhotoSwipeUI_Default from 'photoswipe/src/js/ui/photoswipe-ui-default.js'

import smoothscroll from 'smoothscroll-polyfill'
smoothscroll.polyfill();

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

let mobileNav = function(action) {
  switch(action) {
    case 'open':
      document.body.classList.add('nav-opened')
      break
    case 'close':
      document.body.classList.remove('nav-opened')
      break
    case 'toggle':
      if (document.body.classList.contains('nav-opened')) {
        mobileNav('close')
      } else {
        mobileNav('open')
      }
      break
  }
}


let domReady = function() {
  // Hero
  let hero = document.querySelector('.hero')
  if (hero) {
    // Set initial height
    if (window.matchMedia('(max-width: 799px)').matches) {
      hero.style.height = `calc(${window.innerHeight}px - 4rem)`
    } else {
      hero.style.height = `calc(${window.innerHeight}px - 6.5rem)`
    }

    let images = hero.querySelectorAll('.images .image')
    images[0].style.opacity = 1

    if (images.length > 1) {
      let i = 0
      let zIndex = 1
      window.heroInterval = setInterval(function() {
        let previous = i
        i += 1
        zIndex += 1
        if (i >= images.length) {
          i = 0
        }
        images[i].style.zIndex = zIndex
        images[i].style.opacity = 1
        setTimeout(function() {
          images[previous].style.opacity = 0
        }, 2000)
      }, 6000)
    }

    // Arrow
    let arrowDown = document.querySelector('a.arrow-down')
    if (arrowDown) {
      arrowDown.addEventListener('click', (e) => {
        e.preventDefault()
        let top = (hero.offsetTop + hero.offsetHeight - 88)
        if (window.matchMedia('(max-width: 799px)').matches) {
          top += 88
          top -= 48
        }
        window.scrollTo({
          top: top,
          behavior: 'smooth'
        })
      })
    }
  }

  // Mobile nav
  let burgerNav = document.querySelector('.burger-nav')
  if (burgerNav) {
    burgerNav.addEventListener('click', e => {
      e.preventDefault()
      mobileNav('toggle')
    })
  }

  let closeIcon = document.querySelector('.close-icon')
  if (closeIcon) {
    closeIcon.addEventListener('click', e => {
      e.preventDefault()
      mobileNav('close')
    })
  }

  document.addEventListener('click', e => {
    if (!e.target.closest('header')) {
      mobileNav('close')
    }
  })

  // Gallery
  let gallery = document.querySelector('.gallery')
  if (gallery) {
    let pswpElement = document.querySelector('.pswp')

    // build items array
    let items = []
    let imageLinks = gallery.querySelectorAll('.image a')
    imageLinks.forEach(image => {
      items.push({
        src: image.href,
        w: 1920,
        h: 1280
      })
    })

    // Initializes and opens PhotoSwipe
    imageLinks.forEach((image, index) => {
      image.addEventListener('click', e => {
        e.preventDefault()

        // define options (if needed)
        var options = {
            // optionName: 'option value'
            // for example:
            index: index, // start at first slide,
            shareEl: false,
            zoomEl: false,
            pinchToClose: false,
            maxSpreadZoom: 1,
            getDoubleTapZoom: function(isMouseClick, item) {
              return item.initialZoomLevel;
            },
            history: false
        };

        let popup = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
        popup.init();
      })
    })

  }


}

if (Turbolinks.supported) {
  document.addEventListener("turbolinks:load", domReady)
  document.addEventListener("turbolinks:before-render", function() {
    if (window.heroInterval) clearInterval(window.heroInterval)
  })
} else {
  document.addEventListener('DOMContentLoaded', domReady)
}
